import { PublicClientApplication, type Configuration, type PopupRequest } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_MICROSOFT_CLIENT_ID?.trim() ?? '';

const configuration: Configuration = {
  auth: {
    clientId: clientId || '00000000-0000-0000-0000-000000000000',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: { cacheLocation: 'sessionStorage' },
};

export const microsoftLoginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email'],
  prompt: 'select_account',
};

export const isMicrosoftLoginConfigured = clientId.length > 0;
export const microsoftAuthClient = new PublicClientApplication(configuration);